import React, { useState, useRef, useEffect, useCallback } from "react";
import styled from "styled-components";
import PerfectScrollbar from "react-perfect-scrollbar";

import "react-perfect-scrollbar/dist/css/styles.css";
import { ReactComponent as DropdownCaret } from "../../assets/icons/filter-dropdown-arrow.svg";

const FilterDropdown = ({
    handleFilteredClick,
    filterItems,
    initialName,
    width = "131px",
    height = "48px",
}) => {
    const [selectedFilter, setSelectedFilter] = useState({
        name: initialName,
    });
    const [opened, setOpened] = useState(false);

    const wrapperRef = useRef();

    const handleFilterClick = (item) => {
        setSelectedFilter({
            ...selectedFilter,
            name: item.name,
        });
        setOpened(false);
        handleFilteredClick(item);
    };

    const handleClickOutside = useCallback((event) => {
        if (wrapperRef && !wrapperRef.current.contains(event.target)) {
            setOpened(false);
        }
    }, []);

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [handleClickOutside]);

    return (
        <FilterDropdownWrapper ref={wrapperRef} widthStyled={width} heightStyled={height}>
            <div className="filter-dropdown__box" onClick={() => setOpened(!opened)}>
                <p>{selectedFilter.name}</p>
                <div className="api__home-trans__icon">
                    <DropdownCaret />
                </div>
            </div>
            {opened && (
                <div className="filter-dropdown__dropdown">
                    <PerfectScrollbar style={{ maxHeight: "336px", paddingRight: "4px" }}>
                        {filterItems?.map((item, index) => (
                            <div
                                className="filter-dropdown__dropdown-item"
                                onClick={() => handleFilterClick(item)}
                                key={item.name + index}
                            >
                                <p>{item.name}</p>
                            </div>
                        ))}
                    </PerfectScrollbar>
                </div>
            )}
        </FilterDropdownWrapper>
    );
};

const FilterDropdownWrapper = styled.div`
    position: relative;

    .filter-dropdown__box {
        display: flex;
        min-width: ${({ widthStyled }) => widthStyled};
        height: ${({ heightStyled }) => heightStyled};
        padding: 12px 16px 12px 20px;
        align-items: center;
        border-radius: 10px;
        border: 1px solid #dbdce0;
        background: #fff;
        gap: 10px;
        cursor: pointer;

        p {
            color: #000;
            font-size: 0.8125rem;
            font-weight: 600;
            line-height: 24px;
            white-space: nowrap;
        }

        .api__home-trans__icon {
            margin-top: 3px;
        }
        @media (max-width: 414px) {
            width: ${({ widthStyled }) => widthStyled};
        }
    }
    .filter-dropdown__dropdown {
        position: absolute;
        padding: 4px 8px 20px;
        border-radius: 10px;
        border: 1px solid #dbdce0;
        top: 56px;
        left: 0px;
        z-index: 10000;
        background: #fff;
        min-width: 208px;

        .filter-dropdown__dropdown-item {
            display: flex;
            padding: 16px 8px 16px;
            align-items: flex-start;
            cursor: pointer;
            align-items: center;
            border-bottom: 1px solid #f4f4f4;
            p {
                color: #101828;
                font-size: 0.8125rem;
                font-weight: 600;
                line-height: normal;
                white-space: nowrap;
            }
            &:hover {
                background: #f9f9f9;
            }
        }
    }
    @media (max-width: 450px) {
        margin-right: 10px;
    }
`;

export default FilterDropdown;
